import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "tiers-section"
}
const _hoisted_2 = { class: "tiers-section" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_datetime_button = _resolveComponent("ion-datetime-button")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": _ctx.backHref
                  }, null, 8, ["default-href"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isNew ? 'Новое событие' : 'Редактирование'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            class: "ion-padding event-edit-form",
            onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
          }, [
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("Название *", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.form.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                  "aria-label": "Название события",
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("Описание", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_textarea, {
                  modelValue: _ctx.form.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.description) = $event)),
                  "aria-label": "Описание",
                  rows: 4
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("Место проведения", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.form.location,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.location) = $event)),
                  "aria-label": "Место проведения"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toggle, {
                  checked: _ctx.form.noDate,
                  "aria-label": "Без даты",
                  onIonChange: _ctx.onNoDateToggle
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("Без даты", -1)
                  ]))]),
                  _: 1
                }, 8, ["checked", "onIonChange"])
              ]),
              _: 1
            }),
            (!_ctx.form.noDate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode("Дата и время начала *", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime_button, {
                        id: "start-datetime-btn",
                        datetime: "start-datetime",
                        class: "datetime-trigger",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openStartDatetime = true))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_modal, {
                    class: "datetime-modal",
                    "keep-contents-mounted": "",
                    "is-open": _ctx.openStartDatetime,
                    onDidDismiss: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openStartDatetime = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_datetime, {
                        id: "start-datetime",
                        presentation: "date-time",
                        locale: "ru-RU",
                        "prefer-wheel": false,
                        value: _ctx.form.startAtInput || _ctx.todayIso,
                        "show-default-buttons": "",
                        "done-text": "Готово",
                        "cancel-text": "Отмена",
                        onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onStartDatetimeChange($event))),
                        onIonCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openStartDatetime = false))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["is-open"]),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode("Дата и время окончания", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime_button, {
                        id: "end-datetime-btn",
                        datetime: "end-datetime",
                        class: "datetime-trigger",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openEndDatetime = true))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_modal, {
                    class: "datetime-modal",
                    "keep-contents-mounted": "",
                    "is-open": _ctx.openEndDatetime,
                    onDidDismiss: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openEndDatetime = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_datetime, {
                        id: "end-datetime",
                        presentation: "date-time",
                        locale: "ru-RU",
                        "prefer-wheel": false,
                        value: _ctx.form.endAtInput || _ctx.todayIso,
                        "show-default-buttons": "",
                        "done-text": "Готово",
                        "cancel-text": "Отмена",
                        onIonChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onEndDatetimeChange($event))),
                        onIonCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openEndDatetime = false))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["is-open"])
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toggle, {
                  modelValue: _ctx.form.isPaid,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.isPaid) = $event)),
                  "aria-label": "Платное событие"
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode("Платное событие", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toggle, {
                  modelValue: _ctx.form.published,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.published) = $event)),
                  "aria-label": "Опубликовано"
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("Опубликовано (видно в списке событий)", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("Лимит регистраций (пусто — без лимита)", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  type: "number",
                  modelValue: _ctx.form.maxRegistrations,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.maxRegistrations) = $event)),
                  modelModifiers: { number: true },
                  "aria-label": "Лимит регистраций",
                  min: "1",
                  placeholder: "Не ограничено"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.form.isPaid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _cache[29] || (_cache[29] = _createElementVNode("h3", null, "Тарифы", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.priceTiers, (t, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "tier-row"
                    }, [
                      _createVNode(_component_ion_input, {
                        modelValue: t.name,
                        "onUpdate:modelValue": ($event: any) => ((t.name) = $event),
                        class: "tier-input-name",
                        "aria-label": "Название тарифа",
                        placeholder: "Название тарифа"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_ion_input, {
                        type: "number",
                        modelValue: t.amountRub,
                        "onUpdate:modelValue": ($event: any) => ((t.amountRub) = $event),
                        modelModifiers: { number: true },
                        class: "tier-input-amount",
                        "aria-label": "Стоимость, руб",
                        placeholder: "₽",
                        min: "0"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_ion_select, {
                        modelValue: t.requiredAuthorityName,
                        "onUpdate:modelValue": ($event: any) => ((t.requiredAuthorityName) = $event),
                        class: "tier-role-select",
                        interface: "popover",
                        placeholder: "Роль (необяз.)",
                        "cancel-text": "Отмена",
                        "aria-label": "Роль (необяз.)"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: null }, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createTextVNode("—", -1)
                            ]))]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorities, (a) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: a.name,
                              value: a.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(a.description || a.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        size: "small",
                        class: "tier-row-remove",
                        onClick: ($event: any) => (_ctx.removeTier(i))
                      }, {
                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                          _createTextVNode("×", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  }), 128)),
                  _createVNode(_component_ion_button, {
                    fill: "outline",
                    size: "small",
                    class: "tier-add-btn",
                    onClick: _ctx.addTier
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createTextVNode("+ Тариф", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _cache[30] || (_cache[30] = _createElementVNode("h3", null, "Роли при покупке", -1)),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select, {
                    label: "Выдаваемые роли",
                    "label-placement": "stacked",
                    modelValue: _ctx.form.giftAuthorityNames,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.giftAuthorityNames) = $event)),
                    multiple: "",
                    interface: "alert",
                    "cancel-text": "Отмена",
                    "ok-text": "Готово",
                    placeholder: "Выберите роли"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorities, (a) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: 'gift-' + a.name,
                          value: a.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(a.description || a.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            (!_ctx.isNew && _ctx.eventId)
              ? (_openBlock(), _createBlock(_component_ion_item, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                        _createTextVNode("Логотип", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onLogoChange && _ctx.onLogoChange(...args))),
                      ref: "logoInput",
                      style: {"display":"none"}
                    }, null, 544),
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      class: "logo-upload-btn",
                      onClick: _ctx.openLogoPicker
                    }, {
                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                        _createTextVNode("Загрузить", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.logoPreview)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.logoPreview,
                          class: "logo-preview",
                          alt: ""
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_button, {
              expand: "block",
              type: "submit",
              disabled: _ctx.saving,
              class: "save-event-btn ion-margin-top"
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createTextVNode("Сохранить", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            (!_ctx.isNew)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 3,
                  expand: "block",
                  color: "danger",
                  fill: "outline",
                  disabled: _ctx.saving,
                  onClick: _ctx.remove,
                  class: "ion-margin-top"
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode("Удалить событие", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ], 32)
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}